import { Injectable }                     from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';

@Injectable()
export class SnackbarService {
  constructor(public snackBar: MatSnackBar) {
  }

  /**
   * Display snack bar message
   * @param message
   */
  public addMessage(message: string): void {
    const config = new MatSnackBarConfig();
    config.duration = 7000;

    this.snackBar.open(message, null, config);
  }
}
